import React from 'react';

const DurationCell = ({ duration }) => {
  return <span>{duration} d</span>;
};

export default DurationCell;
